import { de_GetUserDetailsCommand, se_GetUserDetailsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetUserDetailsCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("UserService", "GetUserDetails", {})
    .n("UserServiceClient", "GetUserDetailsCommand")
    .f(void 0, void 0)
    .ser(se_GetUserDetailsCommand)
    .de(de_GetUserDetailsCommand)
    .build() {
}
